<template>
  <v-app>
    <!-- <v-main :dir="lang == 'en' || lang == undefined ? 'ltr' : 'rtl'"> -->
    <v-main :dir="lang == 'ar' ? 'rtl' : 'ltr'">
      <h1>{{ lang }}</h1>
      <!-- <v-main dir="rtl"> -->
      <!-- If Logged In -->
      <!-- if logged in onnnnnnnnnnnnnnly -->
      <div class="" id="content" v-if="isLoggedIn">
        <!-- اوفرفلو بتتحط جوه الديف بتاع اللوجدان لو احتاجتها -->
        <!-- style="overflow: auto !important" -->

        <NavBar v-if="isLoggedIn"> </NavBar>
        <SideBar v-if="isLoggedIn"></SideBar>
        <v-container
          id="wrapper"
          :class="
            !getSideBarMin &&
            (lang == 'undefined' || lang == undefined || lang == 'en')
              ? 'active'
              : lang == 'ar' && !getSideBarMin
              ? 'activeRtl'
              : ''
          "
        >
          <router-view />
        </v-container>
        <!-- <Footer></Footer> -->
      </div>

      <!-- If Not Logged In -->
      <div class="" id="content" v-else>
        <v-container id="" fluid style="max-width: 100% !important">
          <router-view />
        </v-container>
        <!-- <Footer></Footer>  v-if="showNavbar"  v-if="showSidebar"   -->
      </div>
    </v-main>
  </v-app>
</template>

<script>
import ACL from "./acl.js";
import NavBar from "./layout/NavBar.vue";
import SideBar from "./layout/SideBar.vue";
// import Footer from "./layout/Footer.vue";
export default {
  name: "App",
  data: () => ({
    lang: localStorage.locale,

    isLoggedIn: ACL.isLoggedIn(),
  }),

  components: {
    NavBar,
    // Footer,
    SideBar,
  },
  mounted() {
    console.log("lang =", localStorage.locale);
  },
};
</script>

<style lang="scss">
@import "styles/_variables.scss";
@import "styles/_modals.scss";

// // should apply on all views
// #content-loggedIn {
//   padding-bottom: 2rem;
// }
// #wrapper {
//   transition: all 0.4s ease 0s;
//   position: relative;
// }

// #wrapper.activeRtl {
//   text-align: right;
// }
// @media print {
//   #wrapper.active {
//     padding-left: 0;
//   }
//   #wrapper.activeRtl {
//     padding-right: 0;
//   }
// }

#wrapper {
  transition: all 0.4s ease 0s;
  position: relative;
}
#wrapper.activeRtl {
  text-align: right;
}
@media print {
  #wrapper.active {
    padding-left: 0;
  }
  #wrapper.activeRtl {
    padding-right: 0;
  }
}

#wrapper.active {
  // padding-left: 125px;
  // left: 125px !important;
}
#wrapper.activeRtl {
  // padding-right: 125px;
  // right: 125px !important;
}

@media (min-width: 960px) {
  #wrapper {
    left: 25px;
  }
  #wrapper.active {
    // padding-left: 125px;
    left: 125px !important;
  }
  #wrapper.activeRtl {
    // padding-left: 125px;
    right: 125px !important;
  }
}
</style>
